<template>
  <div class="brief-feedback-list">
    <div class="overline grey--text mb-3">Retours sur le brief</div>
    <div v-if="loading" class="caption grey--text">Chargement…</div>
    <v-alert v-else-if="!feedbacks.length" type="info" dense text>
      Aucun retour pour ce brief.
    </v-alert>
    <v-card
      v-for="fb in feedbacks"
      :key="fb.id"
      elevation="0"
      outlined
      class="mb-3 rounded-lg"
    >
      <v-card-text class="pa-3">
        <div class="d-flex align-center mb-1" style="gap: 8px">
          <v-rating
            :value="fb.rating"
            :length="5"
            color="amber darken-1"
            background-color="grey lighten-1"
            dense
            readonly
            small
          />
          <span class="caption grey--text">{{ fb.author_username }}</span>
          <span class="caption grey--text ml-auto">{{ formatDate(fb.created_at) }}</span>
        </div>
        <div v-if="fb.text" class="body-2" style="white-space: pre-wrap">{{ fb.text }}</div>
        <div v-else class="caption grey--text font-italic">Aucun commentaire.</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { fetchBriefFeedbacks } from '@/services/projectApi'

export default {
  name: 'BriefFeedbackList',
  props: {
    projectId: { type: [String, Number], required: true },
  },
  data() {
    return {
      feedbacks: [],
      loading: false,
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        this.feedbacks = await fetchBriefFeedbacks(this.projectId)
      } catch {
        this.feedbacks = []
      } finally {
        this.loading = false
      }
    },
    formatDate(iso) {
      if (!iso) return '—'
      return new Date(iso).toLocaleString('fr-FR', { dateStyle: 'medium', timeStyle: 'short' })
    },
  },
}
</script>
